import {
  CREATE_NEW_PROJECT,
  DELETE_PROJECT,
  SAVE_PROJECT_SNAPSHOT,
  SET_ALL_PROJECTS,
} from "../../actions/imaga-analysis/projectActions";

const initialState = {
  projects: [],
};

export default function imageAnalysisReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ALL_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      };
      break;
    case CREATE_NEW_PROJECT:
      {
        const project = {
          ...action.payload,
          data: null, // snapshot stored here after first save
          updatedAt: Date.now(),
        };
        return { ...state, projects: [project, ...state.projects] };
      }
      break;
    case DELETE_PROJECT:
      {
        const updatedProjects = state.projects.filter(
          (item) => item.id !== action.payload
        );
        return { ...state, projects: updatedProjects };
      }
      break;
    // NEW: write snapshot to the matching project
    case SAVE_PROJECT_SNAPSHOT:
      {
        const { projectId, snapshot } = action.payload;
        const projects = state.projects.map((p) =>
          p.id === projectId
            ? { ...p, data: snapshot, updatedAt: Date.now() }
            : p
        );
        return { ...state, projects };
      }
      break;
    default:
      return state;
  }
}
